import { isNil } from 'lodash';

export default {
  computed: {
    previewImage() {
      return !isNil(this.item) && !isNil(this.item.imageSrc)
        ? this.item.imageSrc
        : '';
    },
  },
  methods: {
    openVideo() {
      this.$nuxt.$emit('openVideo', this.item.videoSrc);
    }
  }
};
